var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSecurityIndustry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.591 18.926l-1.965-1.342.546-.436a.938.938 0 00-.037-1.492L12.11 2.637a1.874 1.874 0 00-2.56.346l-5.924 7.374a1.877 1.877 0 00.372 2.7L8.5 16.273l-1.808 2.57a.938.938 0 00.231 1.309l.645.448a5.67 5.67 0 01-3.935 1.588H1.875v-2.03a.937.937 0 10-1.875 0v9.562a.937.937 0 101.875 0v-1.906h1.27a12.03 12.03 0 008.993-4.041l.937.651a.938.938 0 001.31-.242l1.699-2.493 3.861 2.757a.938.938 0 001.13-.03l1.4-1.118 3.637 2.618a.937.937 0 001.278-.172l4.402-5.455a.938.938 0 00-.2-1.363zM3.146 25.938H1.875v-1.875h1.759a7.545 7.545 0 005.497-2.378l1.454 1.009a10.221 10.221 0 01-7.44 3.244zm10.222-3.594l-4.6-3.194 1.258-1.787 4.531 3.236-1.19 1.745zm7.09.165L5.087 11.53l5.924-7.374 17.027 12.296-7.58 6.056zm6.03 1.367l-2.492-1.794 4.098-3.274 1.601 1.094-3.207 3.974z",
    fill: "#ADC6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 16.47a.937.937 0 100-1.875.937.937 0 000 1.875z",
    fill: "#ADC6FF"
  })));
}

export default __webpack_public_path__ + "./fonts/security-industry.994b118019dcd0cddbaec3ce80a91569.svg";
export { SvgSecurityIndustry as ReactComponent };